const qualityList = [
  {
    id: 1,
    title: '专利基础知识'
  },
  {
    id: 2,
    title: '专利数据分析'
  },
  {
    id: 3,
    title: '专利数据管理'
  },
  {
    id: 4,
    title: '专利前置评审'
  },
  {
    id: 5,
    title: '专家资源支持'
  },
  {
    id: 6,
    title: '专利培训资料'
  }
]

const worthList = [
  {
    id: 1,
    title: '专利分级分类'
  },
  {
    id: 2,
    title: '专利代理服务'
  }
]

const infoList = [
  {
    id: 1,
    title: '专利主题监控'
  },
  {
    id: 2,
    title: '专利交流活动'
  }
]

module.exports = {
  qualityList,
  worthList,
  infoList
}
